import { createTheme } from "@mui/material";

export const loginTheme = createTheme({
  palette: {
    mode: "light",
    background: {
      default: "transparent",
    },
    text: {
      primary: "#000000",
      secondary: "#555555",
    },
    primary: {
      main: "#1976d2",
    },
  },
});

export const errorTextFieldStyles = {
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#d32f2f",
    },
    "&:hover fieldset": {
      borderColor: "#d32f2f",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#d32f2f",
    },
  },
};
